import styled from "styled-components";
export const Container = styled.section`
  overflow: auto;
  width: 90vw;
  height: 80%;
  max-width: 1000px;
  max-height: 570px;
  display: flex;
  padding: 1rem;
  align-items: center;
  // justify-content: center;
  flex-flow: column nowrap;
  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    > div,
    > article {
      margin: 1rem;
    }
  }

  ::-webkit-scrollbar {
    width: 0.5rem;
  }
  ::-webkit-scrollbar-track {
    background: #ececec;
    -webkit-border-radius: 10px;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: var(--secondary-color);
    -webkit-border-radius: 10px;
    border-radius: 10px;
  }
`;
